"use client";

import { ALargeSmall, Moon, ScanQrCode, Search } from "lucide-react";
import Link from "next/link";
import { Translations } from "@/Languages";
import TextSizeButton from "./TextSizeButton";
import DarkModeButton from "./DarkModeButton";
import { useEffect } from "react";

export default function Navigation({ LANG }: Readonly<{ LANG: Translations }>) {
  useEffect(() => {
    document.documentElement.classList.toggle(
      "dark",
      window.matchMedia("(prefers-color-scheme: dark)").matches,
    );
  }, []);

  return (
    <nav className="bg-primary flex h-16 items-center text-white">
      <div className="container mx-auto flex gap-1">
        <Link href="/explore" className="flex flex-1 flex-col items-center">
          <Search />
          <p className="text-xs">{LANG.explore}</p>
        </Link>

        <Link href="/scan" className="flex flex-1 flex-col items-center">
          <ScanQrCode />
          <p className="text-xs">{LANG.qr}</p>
        </Link>

        <TextSizeButton className="flex flex-1 flex-col items-center">
          <ALargeSmall />
          <p className="text-xs">{LANG.size}</p>
        </TextSizeButton>

        <DarkModeButton className="flex flex-1 flex-col items-center">
          <Moon />
          <p className="text-xs">{LANG.toggleDarkMode}</p>
        </DarkModeButton>
      </div>
    </nav>
  );
}
